import { useContext } from "react";

// Font Awesome
import { faTimes as faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// style
import Style from "./ModalApproveProject.module.css";

// context
import Cookies from "universal-cookie";
import { AdminDashboardContext } from "../../../../../context/AdminDashboardContext";
// importing api requests
import {
  approveFirstFormSubmit,
  approveSecondFormSubmit,
} from "../../ApiRequests";

const ModalApproveProject = () => {
  const {
    setModalApproveProjectIsOpen,
    intentionSelection,
    approvalSelection,
    selectedProject,
    setModalMessageIsOpen,
    setMessageForModal,
    setLoadingSpinnerIsOpen,
    setIsApprovedProject,
  } = useContext(AdminDashboardContext);

  const handleYesButton = async () => {
    const username = new Cookies(null, { path: "/" }).get("username");
    if (intentionSelection) {
      setModalApproveProjectIsOpen(false);
      setLoadingSpinnerIsOpen(true);

      const check = await approveFirstFormSubmit(selectedProject.id, username);

      if (check) {
        setMessageForModal("Projekt je uspješno odobren!");
        setModalMessageIsOpen(true);
        setLoadingSpinnerIsOpen(false);
        setIsApprovedProject(true);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (!check) {
        setMessageForModal("Provjerite internet vezu!");
        setModalMessageIsOpen(true);
        setLoadingSpinnerIsOpen(false);
        setIsApprovedProject(false);
      }
    } else if (approvalSelection) {
      setModalApproveProjectIsOpen(false);
      setLoadingSpinnerIsOpen(true);
      const check = await approveSecondFormSubmit(selectedProject, username);
      if (check) {
        setMessageForModal("Projekt je uspješno odobren!");
        setModalMessageIsOpen(true);
        setLoadingSpinnerIsOpen(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (!check) {
        setMessageForModal("Provjerite internet vezu!");
        setModalMessageIsOpen(true);
        setLoadingSpinnerIsOpen(false);
      }
    } else {
      window.alert("Greška u odabiru namjere!");
    }
  };

  const handleNoButton = () => {
    setModalApproveProjectIsOpen(false);
  };

  const closeModal = () => {
    setModalApproveProjectIsOpen(false);
  };

  return (
    <div className={Style.ModalContainerOverlay}>
      <div className={Style.Modal}>
        <div className={Style.ModalTopContainer}>
          <button className={Style.ModalClose} onClick={() => closeModal()}>
            <FontAwesomeIcon icon={faXmark} size="1x" />
          </button>
          <h3 className={Style.ModalQuestion}>Odobri projekt?</h3>
        </div>

        <div className={Style.ModalButtonsContainer}>
          <button
            onClick={() => handleYesButton()}
            className={Style.ModalButton}
          >
            DA
          </button>
          <button
            onClick={() => handleNoButton()}
            className={Style.ModalButton}
          >
            NE
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalApproveProject;
